/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem, SortableArrayField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { postBy, formatArticleError } from '@utils';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

import { FORM_FIELD } from './constants';

const ArticleItem = ({ article }) => {
  const { media } = useMedia(getImage(article, 'featureImage'));

  if (article instanceof Error) {
    const error = article;
    return <InfoItem>{formatArticleError(error)}</InfoItem>;
  }

  return (
    <InfoItem image={media.src} description={postBy(article)}>
      {article.title}
    </InfoItem>
  );
};

const ArticleListField = ({ form }) => {
  return (
    <SortableArrayField {...FORM_FIELD.ARTICLES} style={NO_MARGIN_BOTTOM} form={form} withPlaceholder withCount>
      {(article) => article && <ArticleItem article={article} />}
    </SortableArrayField>
  );
};

export default ArticleListField;
